export default {
    dependencies: ['$element', 'trackingservice'],
    callable(element, trackingService) {
        const widgetContainer = element.querySelector(
            '[data-finnbox-id=widget_container]'
        );
        const widget = FINN.finnbox.conversationsWidget.create(widgetContainer);

        widget.init();

        trackingService.trackEventObject({
            analyticsName: 'contact.contact-from-ad-admin-page.show-widget',
            eventFlags: 'start,success',
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/autoexpandedFinnboxWidget.js